import * as React from "react";
interface props {
  className?: string;
}
const LivabilitySvg = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    // width="70"
    // height="70"
    className={className}
    fill="none"
    viewBox="0 0 70 70"
  >
    <path
      fill="#FF752C"
      d="M32.234 1.8c-.077-.927.613-1.746 1.543-1.779A35 35 0 1 1 14.755 6.45c.76-.538 1.804-.306 2.306.479.5.784.268 1.822-.488 2.365a31.63 31.63 0 1 0 17.484-5.909c-.93.028-1.745-.656-1.823-1.584"
    ></path>
    <path
      fill="#A1A0A0"
      d="M41.75 36.5h-7.19l2.1-2.1c.76.382 1.597.586 2.447.596a4.65 4.65 0 0 0 2.427-.677c2.224-1.346 3.416-4.463 3.188-8.336a.75.75 0 0 0-.705-.705c-3.874-.228-6.99.963-8.337 3.187-.877 1.449-.9 3.198-.081 4.875l-1.35 1.35-1.144-1.145c.563-1.243.522-2.532-.13-3.608-1.02-1.687-3.355-2.586-6.25-2.416a.75.75 0 0 0-.705.704c-.17 2.894.73 5.23 2.417 6.25a3.6 3.6 0 0 0 1.875.525c.6-.005 1.192-.14 1.737-.392l1.14 1.142-.75.75h-4.19a.75.75 0 0 0 0 1.5h.9l1.238 5.576a1.49 1.49 0 0 0 1.465 1.174h6.297a1.49 1.49 0 0 0 1.464-1.174L40.852 38h.898a.75.75 0 1 0 0-1.5"
    ></path>
  </svg>
);

export default LivabilitySvg;
